import { FC } from "react";
import { Box } from "@mui/material";

import ImgArrows from "../../assets/images/products/arrows.svg";

interface Props {
  title: string;
  text: string;
}

const BitaCoreListItem: FC<Props> = ({ title, text }) => {
  return (
    <Box
      sx={{
        position: "relative",
        paddingLeft: "2.5rem",
        paddingRight: { xs: 0, md: "4rem" },
        margin: { xs: "0.75rem 0", md: "1rem 0" },
        fontSize: 18,
        lineHeight: "30px",
      }}
    >
      <Box sx={{ position: "absolute", top: "0.25rem", left: "0.5rem" }}>
        <img src={ImgArrows} alt="Arrows" />
      </Box>
      <Box sx={{ fontWeight: 700 }}>{title}</Box>
      <Box>{text}</Box>
    </Box>
  );
};

export default BitaCoreListItem;
